/* tslint:disable */
import { Injectable } from '@angular/core';
import { Puesto } from '../../models/Puesto';
import { Turno } from '../../models/Turno';
import { Numerador } from '../../models/Numerador';
import { Sucursal } from '../../models/Sucursal';
import { Totem } from '../../models/Totem';
import { Sector } from '../../models/Sector';
import { PadronNosis } from '../../models/PadronNosis';
import { ConsultasSql } from '../../models/ConsultasSql';
import { PadronOlp } from '../../models/PadronOlp';
import { Encuestas } from '../../models/Encuestas';
import { Preguntas } from '../../models/Preguntas';
import { TipoPregunta } from '../../models/TipoPregunta';
import { EncuestaRespuestas } from '../../models/EncuestaRespuestas';
import { EncuestaRespuestasDetalle } from '../../models/EncuestaRespuestasDetalle';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    Puesto: Puesto,
    Turno: Turno,
    Numerador: Numerador,
    Sucursal: Sucursal,
    Totem: Totem,
    Sector: Sector,
    PadronNosis: PadronNosis,
    ConsultasSql: ConsultasSql,
    PadronOlp: PadronOlp,
    Encuestas: Encuestas,
    Preguntas: Preguntas,
    TipoPregunta: TipoPregunta,
    EncuestaRespuestas: EncuestaRespuestas,
    EncuestaRespuestasDetalle: EncuestaRespuestasDetalle,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/services/custom/SDKModels.ts